import { Component } from '@angular/core';
import { TagFieldComponent } from '@src/app/shared/components/tag-field/tag-field.component';

@Component({
  selector: 'app-tag-field-category',
  templateUrl: './tag-field-category.component.html',
})
export class TagFieldCategoryComponent extends TagFieldComponent {
  updateItemsStatus(): void {
    if (this.items && this.items.length > 0) {
      for (const item of this.items) {
        if (item.disableTagEdit) {
          item.readonly = true;
        } else {
          item.readonly = !this.editable;
        }
      }
    }
  }
}
